import { getApiActionTypes } from '../../shared/store/storeHelpers';

export const countRootEntitiesByStateTypes = getApiActionTypes(
  'COUNT_ROOT_ENTITIES_BY_STATE_TYPES',
);

export const fetchIncomeTaxLiabilityTypes = getApiActionTypes('FETCH_INCOME_TAX_LIABILITY_TYPES');
